// noinspection DuplicatedCode
import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";


import {
    getLemburReport,
    getLemburReportDetail,
    lemburTransaksiSelector,
    resetLemburSlice,
} from "./lemburTransaksiSlice";

import {Colors} from "../../../../assets/Colors";
import Skeltons from "../../../../components/loading/Skeltons";
import DynamicTable from "../../../../components/tablecard/DynamicTable";
import {Card} from "@material-tailwind/react";
import {HrdInputGenerator} from "../../../../components/form/HrdInputGenerator";
import {useForm} from "../../../../components/isRequired";
import HrdReportModal from "../../../../components/modal/HrdReportModal";
import {downloadExcel} from "react-export-table-to-excel";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

// ── Helper tanggal/durasi — duplikat dari LemburPage.js (transaksi/lembur) supaya
// kolom "Tanggal" & "Durasi Lembur" di report identik persis dengan transaksi.
const parseLemburTgl = (s) => {
    if (!s) return null;
    const str = String(s).trim();
    let m = str.match(/^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})(?::(\d{2}))?/);
    if (m) return new Date(+m[1], +m[2] - 1, +m[3], +m[4], +m[5], +(m[6] || 0));
    m = str.match(/^(\d{2})-(\d{2})-(\d{4})[T ](\d{2}):(\d{2})(?::(\d{2}))?/);
    if (m) return new Date(+m[3], +m[2] - 1, +m[1], +m[4], +m[5], +(m[6] || 0));
    const d = new Date(str);
    return isNaN(d.getTime()) ? null : d;
};
const formatDurasiLembur = (mulai, akhir) => {
    const a = parseLemburTgl(mulai);
    const b = parseLemburTgl(akhir);
    if (!a || !b) return "-";
    const menitTotal = Math.max(0, Math.round((b - a) / 60000));
    const jam = Math.floor(menitTotal / 60);
    const menit = menitTotal % 60;
    return menit > 0 ? `${jam} jam ${menit} menit` : `${jam} jam`;
};
const pad2 = (n) => String(n).padStart(2, "0");
const fmtTglJam = (d) => `${pad2(d.getDate())}-${pad2(d.getMonth() + 1)}-${d.getFullYear()} ${pad2(d.getHours())}:${pad2(d.getMinutes())}`;
// Sama seperti "TanggalMonitoring" di transaksi ("DD-MM-YYYY HH:MM sd DD-MM-YYYY HH:MM").
const formatTanggalLembur = (mulai, akhir) => {
    const a = parseLemburTgl(mulai);
    const b = parseLemburTgl(akhir);
    if (!a) return "-";
    return b ? `${fmtTglJam(a)} sd ${fmtTglJam(b)}` : fmtTglJam(a);
};
// Warna badge status — sama persis dgn statusClass() di LemburPage.js.
const statusClass = (s) =>
    s === "Selesai"
        ? "bg-green-100 text-green-800"
        : s === "Belum Dikirim"
        ? "bg-gray-100 text-gray-700"
        : "bg-yellow-100 text-yellow-800";
// Node visual kolom Approval — badge status + daftar aktor, identik dgn markup
// <td> Approval di LemburPage.js. DynamicTable merender `texts` apa adanya
// (lihat DynamicTable.js baris ~262 `{texts}`), jadi elemen JSX ini akan
// tampil sama persis, bukan cuma teks polos.
const renderApprovalNode = (r) => (
    <>
        <span className={`px-2 py-1 rounded-full text-xs font-semibold ${statusClass(r.StatusKet)}`}>
            {r.StatusKet || "-"}
        </span>
        {Array.isArray(r.ApprovalList) && r.ApprovalList.length > 0 && (
            <div className="mt-2 space-y-0.5 text-xs text-gray-700">
                {r.ApprovalList.map((a, ai) => (
                    <div key={ai} className="whitespace-nowrap">
                        {a.Status} {a.Nama}
                    </div>
                ))}
            </div>
        )}
    </>
);

const LemburReport = ({}) => {
    let initialState = {
        bulan: new Date(),
        region: "L0001",
    };
    let initialStateDetail = {
        "Nik": "",
        "NamaKaryawan": "",
        "TglMasuk": "",
        "Jabatan": "",
        "Golongan": "",


    };
    const validations = [];

    const {
        values,
        errors,
        touched,
        changeHandler,
        customHandler,
    } = useForm(initialState, validations);

    const [data, setData] = useState(null);
    const [dataUpkeep, setDataUpkeep] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [detail, setDetail] = useState(initialStateDetail);
    // Periode yang sedang diterapkan pada list; dipakai agar popup detail
    // menampilkan lembur karyawan HANYA untuk periode ini. bulan "" = semua bulan.
    const [appliedPeriod, setAppliedPeriod] = useState({
        tahun: new Date().getFullYear().toString(),
        bulan: "",
    });
    const [selectedBU, setSelectedBU] = useState("");
    const [selectedBagian, setSelectedBagian] = useState("");
    const [searchText, setSearchText] = useState("");
    const [pageC, setPageC] = useState(1);
    // Skeleton loading — mengikuti pola LemburPage (transaksi/lembur): true
    // sejak dispatch sampai isGetReport balik (fulfilled/rejected).
    const [fetching, setFetching] = useState(true);
    const PAGE_SIZE = 10;

    const lembur = useSelector(lemburTransaksiSelector);

    const dispatch = useDispatch();
    useEffect(() => {
        const tahun = values.bulan.getFullYear().toString();
        setFetching(true);
        // .finally() dipakai (bukan cuma mengandalkan isGetReport) supaya skeleton
        // tetap turun walau request gagal — dispatch thunk selalu resolve.
        dispatch(
            getLemburReport({
                "tahun": tahun,
                "bulan": "",
                "region": ""   // semua lokasi; filter Bisnis Unit/Bagian dilakukan client-side
            })
        ).finally(() => setFetching(false));
        setAppliedPeriod({ tahun: tahun, bulan: "" });
    }, []);


    useEffect(() => {
        if (lembur.isGetReport) {
            dispatch(resetLemburSlice({}))
            if (!lembur.report) {
                setData([])
            } else {
                setData(lembur.report)
            }
            setDataUpkeep(lembur.report)
            setFetching(false)
        }
    });

    // Kolom disamakan dengan colHeader di LemburPage.js (transaksi/lembur), minus
    // "Actions" (report murni tampilan) — plus Bisnis Unit/Bagian (report lintas-BU,
    // transaksi tidak perlu ini karena scope-nya sudah per-user).
    const header = [
        {name: "ID", key: "TLemburID", modifiers: "Text"},
        {name: "No SPL", key: "SPL", modifiers: "Text"},
        {name: "Nama Karyawan", key: "NamaKaryawan", modifiers: "Text"},
        {name: "Bisnis Unit", key: "NamaBisnisUnit", modifiers: "Text"},
        {name: "Bagian", key: "NamaBagian", modifiers: "Text"},
        {name: "Keperluan Lembur", key: "KeperluanLembur", modifiers: "Text"},
        {name: "Tanggal", key: "TanggalLabel", modifiers: "Text"},
        {name: "Durasi Lembur", key: "DurasiLabel", modifiers: "Text"},
        // Akumulasi Durasi = TLembur.FaktorLembur (jam ekivalen PP35 untuk transaksi
        // ini, dipakai backend mengalikan UpahSejam). Kosong utk dokumen sebelum PP35.
        {name: "Akumulasi Durasi", key: "AkumulasiDurasiLabel", modifiers: "Text"},
        // ApprovalNode = elemen JSX (badge + daftar aktor), bukan string — lihat
        // renderApprovalNode di atas. Tampilannya identik dgn kolom Approval transaksi.
        {name: "Approval", key: "ApprovalNode", modifiers: "Text"},
    ]

    // Search bar bawaan DynamicTable → set kata kunci (client-side).
    const filterData = (event) => {
        setSearchText(event?.target?.value ?? "");
    }

    // ── Filter Bisnis Unit + Bagian (masih tersedia sbg filter meski BU/Bagian
    // tak lagi jadi kolom tabel) + search (client-side) ──
    // Label turunan dibuat sama persis dgn cara LemburPage (transaksi) menampilkannya.
    const baseRows = (Array.isArray(data) ? data : []).map((r) => ({
        ...r,
        AkumulasiDurasiLabel: r.AkumulasiDurasi ? `${r.AkumulasiDurasi} jam` : "-",
        DurasiLabel: formatDurasiLembur(r.TanggalMulai, r.TanggalAkhir),
        TanggalLabel: formatTanggalLembur(r.TanggalMulai, r.TanggalAkhir),
        // ApprovalLabel = versi teks polos (Export Excel/PDF + pencarian, yang tak
        // bisa merender JSX). ApprovalNode = versi visual utk tabel di layar.
        ApprovalLabel: [
            r.StatusKet || "",
            ...(Array.isArray(r.ApprovalList) ? r.ApprovalList.map((a) => `${a.Status} ${a.Nama}`) : []),
        ].filter(Boolean).join(" | "),
        ApprovalNode: renderApprovalNode(r),
    }));
    const buOptions = Array.from(
        new Set(baseRows.map((r) => r.NamaBisnisUnit).filter(Boolean))
    ).sort((a, b) => a.localeCompare(b));
    const bagianOptions = Array.from(
        new Set(
            baseRows
                .filter((r) => !selectedBU || r.NamaBisnisUnit === selectedBU)
                .map((r) => r.NamaBagian)
                .filter(Boolean)
        )
    ).sort((a, b) => a.localeCompare(b));
    const displayData = baseRows.filter((r) => {
        if (selectedBU && r.NamaBisnisUnit !== selectedBU) return false;
        if (selectedBagian && r.NamaBagian !== selectedBagian) return false;
        const kw = searchText.trim().toLowerCase();
        if (!kw) return true;
        // Field pencarian disamakan dgn LemburPage: ID/No SPL/Nama/Keperluan/Tanggal/Status.
        return [r.TLemburID, r.SPL, r.NamaKaryawan, r.KeperluanLembur, r.TanggalLabel, r.StatusKet, r.NamaBisnisUnit, r.NamaBagian]
            .some((v) => v && v.toString().toLowerCase().includes(kw));
    });

    // ── Pagination (client-side, mengikuti hasil filter/search) ──
    const totalPage = Math.max(1, Math.ceil(displayData.length / PAGE_SIZE));
    const safePage = Math.min(pageC, totalPage);
    const pageRows = displayData.slice((safePage - 1) * PAGE_SIZE, (safePage - 1) * PAGE_SIZE + PAGE_SIZE);

    useEffect(() => {
        setPageC(1);
    }, [searchText, selectedBU, selectedBagian, data]);

    // ── Export (mengikuti hasil filter yang tampil) ──
    const exportHeader = [
        "ID", "No SPL", "Nama Karyawan", "Bisnis Unit", "Bagian", "Keperluan Lembur", "Tanggal", "Durasi Lembur", "Akumulasi Durasi", "Approval",
    ];
    const exportBody = () =>
        displayData.map((r) => [
            r.TLemburID || "", r.SPL || "", r.NamaKaryawan || "", r.NamaBisnisUnit || "", r.NamaBagian || "",
            r.KeperluanLembur || "", r.TanggalLabel || "", r.DurasiLabel || "", r.AkumulasiDurasiLabel || "-", r.ApprovalLabel || "",
        ]);
    const handleExportExcel = () => {
        if (!displayData.length) return;
        downloadExcel({
            fileName: "Report_Lembur_" + appliedPeriod.tahun,
            sheet: "data",
            tablePayload: { header: exportHeader, body: exportBody() },
        });
    };
    const handleExportPDF = () => {
        if (!displayData.length) return;
        const doc = new jsPDF({ orientation: "landscape" });
        doc.setFontSize(12);
        doc.text("Report Lembur " + appliedPeriod.tahun, 14, 14);
        autoTable(doc, {
            head: [exportHeader],
            body: exportBody(),
            startY: 20,
            styles: { fontSize: 7, cellPadding: 2 },
            headStyles: { fillColor: [47, 85, 151], textColor: 255, fontStyle: "bold" },
        });
        doc.save("Report_Lembur_" + appliedPeriod.tahun + ".pdf");
    };
    // Tahun = filter server; report menampilkan SEMUA bulan pada tahun tsb.
    const filterApi = () => {
        const tahun = values.bulan.getFullYear().toString();
        setFetching(true);
        dispatch(
            getLemburReport({
                "tahun": tahun,
                "bulan": "",
                "region": ""
            })
        ).finally(() => setFetching(false));
        setAppliedPeriod({ tahun: tahun, bulan: "" });
        setData([])
        setDataUpkeep(null)
    }

    const ModalOpener = (detail) => {
        // Sertakan periode yang sedang difilter agar backend menyaring lembur
        // karyawan ini hanya untuk Bulan/Tahun tsb (bukan semua periode).
        const detailWithPeriod = {
            ...detail,
            Tahun: appliedPeriod.tahun,
            Bulan: appliedPeriod.bulan,
        };
        dispatch(getLemburReportDetail(detailWithPeriod))
        setShowModal(!showModal)
        setDetail(detailWithPeriod)
    }
    return (
        <>
            <div className="md:ml-64">
                <div
                    style={{background: Colors.primary}}
                    className="pt-14 pb-16 px-3 md:px-8 h-auto"
                >
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
                    </div>
                </div>
                <div className="px-3 md:px-8 h-auto -mt-32">
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 px-4">
                            <Card>
                                {/* ── Filter row (Periode + Bisnis Unit + Bagian) — sama seperti transaksi/lembur ── */}
                                <div className="flex flex-row flex-wrap items-end gap-3 px-4 py-3">
                                    <div className="flex flex-col">
                                        <label className="text-xs font-bold uppercase text-gray-600 mb-1">Tahun</label>
                                        <DatePicker
                                            showYearPicker
                                            dateFormat="yyyy"
                                            selected={values.bulan ? new Date(values.bulan) : new Date()}
                                            onChange={(date) => customHandler(date, "bulan")}
                                            className="border border-gray-300 rounded px-3 text-sm bg-white h-[42px] w-28 outline-none"
                                        />
                                    </div>
                                    <button type="button"
                                            onClick={filterApi}
                                            className="flex items-center justify-center h-[42px] text-main-100 hover:text-white border border-main-100 hover:bg-main-100 font-medium rounded-lg text-sm px-6">
                                        Buka
                                    </button>
                                    <div className="flex flex-col">
                                        <label className="text-xs font-bold uppercase text-gray-600 mb-1">Bisnis Unit</label>
                                        <select value={selectedBU}
                                                onChange={(e) => { setSelectedBU(e.target.value); setSelectedBagian(""); }}
                                                className="border border-gray-300 rounded px-3 text-sm bg-white h-[42px] min-w-[180px] outline-none">
                                            <option value="">Semua Bisnis Unit</option>
                                            {buOptions.map((n) => <option key={n} value={n}>{n}</option>)}
                                        </select>
                                    </div>
                                    <div className="flex flex-col">
                                        <label className="text-xs font-bold uppercase text-gray-600 mb-1">Bagian</label>
                                        <select value={selectedBagian}
                                                onChange={(e) => setSelectedBagian(e.target.value)}
                                                className="border border-gray-300 rounded px-3 text-sm bg-white h-[42px] min-w-[200px] outline-none">
                                            <option value="">Semua Bagian</option>
                                            {bagianOptions.map((n) => <option key={n} value={n}>{n}</option>)}
                                        </select>
                                    </div>
                                </div>

                                {fetching ? (
                                    <div className="w-full pt-0">
                                        <Skeltons />
                                    </div>
                                ) : (
                                    <>
                                        {/* ── Toolbar: Export kiri, Cari kanan — baris terpisah dari filter ── */}
                                        <div className="flex w-full justify-between px-4 pt-2 flex-col sm:flex-row mt-2 gap-2">
                                            <div className="flex flex-row gap-2 flex-wrap">
                                                <button onClick={handleExportExcel}
                                                        className="flex items-center justify-center gap-2 h-[42px] px-4 rounded shadow text-sm font-semibold border bg-white text-gray-800 border-green-600 hover:bg-green-600 hover:text-white">
                                                    Export Excel
                                                </button>
                                                <button onClick={handleExportPDF}
                                                        className="flex items-center justify-center gap-2 h-[42px] px-4 rounded shadow text-sm font-semibold border bg-white text-gray-800 border-red-400 hover:bg-red-400 hover:text-white">
                                                    Export PDF
                                                </button>
                                            </div>
                                            <div className="flex flex-row w-full sm:w-96">
                                                <input type="text" value={searchText}
                                                       onChange={(e) => setSearchText(e.target.value)}
                                                       placeholder="Cari ID / No SPL / Nama / Keperluan"
                                                       className="px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 w-full h-[42px]"/>
                                            </div>
                                        </div>

                                        <div className="flex flex-col items-center content-center ">
                                            <DynamicTable withoutAttribut={true} data={pageRows} header={header}
                                                          OnClick={ModalOpener}/>
                                        </div>

                                        {/* ── Info + Pagination ── */}
                                        <div className="flex flex-row justify-between items-center gap-4 px-4 py-4 text-sm text-gray-600">
                                            <span>{displayData.length} data — tahun {appliedPeriod.tahun}</span>
                                            <div className="flex items-center gap-4">
                                                <button onClick={() => setPageC((p) => Math.max(1, p - 1))} disabled={safePage <= 1}
                                                        className="border px-4 py-1 rounded disabled:opacity-50 hover:bg-gray-100">Prev</button>
                                                <span>Page {safePage} / {totalPage}</span>
                                                <button onClick={() => setPageC((p) => Math.min(totalPage, p + 1))} disabled={safePage >= totalPage}
                                                        className="border px-4 py-1 rounded disabled:opacity-50 hover:bg-gray-100">Next</button>
                                            </div>
                                        </div>
                                    </>
                                )}
                                {lembur.reportDetail &&
                                    <HrdReportModal showModal={showModal} setShowModal={setShowModal}
                                                    detail={lembur.reportDetail}
                                                    type={"lembur"}/>

                                }
                            </Card>
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
};

export default LemburReport;
